import { useScaffold } from "../../scaffold";

export const CloseWindowPrompt: React.FC = () => {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;

  return (
    <PageBody>
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 gap-4 flex flex-col text-center">
        <div className="flex flex-col gap-2">
          <Title>You're all set</Title>
          <Subtitle>You can close this window.</Subtitle>
        </div>
      </div>
    </PageBody>
  );
};
